

export { InputControl } from './src/input-control';
